import { render, staticRenderFns } from "./designDataSourceDialog.vue?vue&type=template&id=4e5d05cc&"
import script from "./designDataSourceDialog.vue?vue&type=script&lang=js&"
export * from "./designDataSourceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports